// 团队成员标签下拉框数据内容所属类型
const teamMemberLabelTypes = ['销售人员', '非销售人员'];
export const TEAM_MEMBER_LABEL_SELECT_OPTIONS = teamMemberLabelTypes.map((label, index) => ({
  label,
  value: index + 1,
}));

export const a = 1;
